import { Marker } from '@react-google-maps/api'
import React from 'react'

export default function CurrLocationMarker ({ props }) {
  const { position, handleZoom, stroke, scale } = props
  const icon = {
    scale,
    fillColor: 'green',
    fillOpacity: 1,
    strokeWeight: stroke,
    strokeColor: '#c1ebb9'
  }
  if (props.url) {
    icon.url = props.url
  } else {
    icon.path = 0
  }

  return (
    <Marker
      position={position}
      onLoad={marker => {
        marker.setIcon(
          icon
        )
        handleZoom(14)
      }}
    />
  )
}
